<template>
  <BaseWrapper>
    <div class="grid grid-cols-1 md:grid-cols-2">
      <LoginStats v-if="checkHasPermission('users.read_login_stats')" />
    </div>
  </BaseWrapper>
</template>

<script>
import { mapGetters } from 'vuex';
import LoginStats from '../../../../components/admin/stats/LoginStats.vue';

export default {
  components: { LoginStats },
  computed: {
    ...mapGetters({
      checkHasPermission: 'auth/checkHasPermission'
    })
  }
}
</script>